import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./Auth.css";
import logo from "../../assets/logo_project.png";
import Swal from "sweetalert2";
import ScaleLoader from "react-spinners/ScaleLoader"; 
import { useMsal } from "@azure/msal-react";

interface AuthProps {
    onLogin: (token?: string) => void;
}
interface IdTokenClaimsWithRoles {
    roles?: string[];
    [key: string]: any;
}

const Auth: React.FC<AuthProps> = ({ onLogin }) => {
    const navigate = useNavigate();
    const captcha = useRef<ReCAPTCHA>(null);
    const [isAuthenticating, setIsAuthenticating] = useState(false); 
    const { instance, accounts } = useMsal();

    const handleLoginAAD = async () => {
        try {
            const loginResponse = await instance.loginPopup({
                scopes: ["openid", "profile", "email"]
            });
            // No registrar loginResponse ni sus tokens en consola: el objeto contiene
            // idToken, accessToken e idTokenClaims, y la consola es legible por
            // extensiones del navegador y queda en capturas de pantalla.

            sessionStorage.setItem("user_info", JSON.stringify(loginResponse));
            sessionStorage.setItem("authToken", loginResponse.idToken);
            sessionStorage.setItem("userName", loginResponse.account.username.split('@')[0]);
            sessionStorage.setItem("userEmail", loginResponse.account.username);
            
            const claims = loginResponse.idTokenClaims as IdTokenClaimsWithRoles;
            const roles = Array.isArray(claims.roles) ? claims.roles : [];
            sessionStorage.setItem("roles", JSON.stringify(roles));
            onLogin(loginResponse.idToken);
            navigate("/");

        } catch (error) {
            console.error("Login Failed: ", error);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-background">
                <div className="hero-content">
                    <div className="container-logo">
                        <img src={logo} alt="" className="logo" />
                    </div>
                    <h1>Soy Wilson, tu Asistente Experto</h1>
                    <p>
                        Te ayudo a consultar rápidamente información de productos, accediendo mediante lenguaje natural a manuales, guías de reparación y documentación interna para resolver dudas y agilizar tu trabajo.
                    </p>
                </div>
            </div>
            <div className="auth-container-form">
                <div className="container-card">
                    <div className="container-logo">
                        <img src={logo} alt="" className="logo" />
                    </div>
                    <div className="form-container">
                        {isAuthenticating ? ( 
                            <ScaleLoader color="#2f9f91" height={15} width={2} radius={2} margin={2} />
                        ) : (
                            <input type="submit" value="Ingresar" onClick={handleLoginAAD} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Auth;
